/* Recurring countdown (Timer Mode = Recurring).
   Markup: an element with data-ygh-recurring, data-end="2026-10-22T13:59:59" and data-days="1",
   holding [data-cd-d] [data-cd-h] [data-cd-m] [data-cd-s]. It resets every N days at the time in
   data-end, read as US Eastern wall-clock time (DST-aware), so T13:59:59 + 1 day = zero every day at
   13:59:59 ET. With no [data-cd-d] the days are added to the hours (two days reads 48H), same as
   ygh-countdown.js. A data-end that isn't a date (e.g. "nightly") falls back to cycles from midnight UTC. */
(function () {
  if (window.__yghRecurring) { window.__yghRecurring(); return; }
  var etf = null;
  try {
    etf = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  } catch (e) {}
  function nowET() {
    if (!etf) return Date.now() - 5 * 3600000;
    var o = {};
    etf.formatToParts(new Date()).forEach(function (x) { o[x.type] = x.value; });
    return Date.UTC(+o.year, o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second) + Date.now() % 1000;
  }
  function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
  function set(root, sel, v) { var e = root.querySelector(sel); if (e) e.textContent = v; }
  var timers = [];
  function scan() {
    document.querySelectorAll('[data-ygh-recurring]:not([data-ygh-recurring-on])').forEach(function (el) {
      el.setAttribute('data-ygh-recurring-on', '');
      var days = parseInt(el.getAttribute('data-days'), 10) || 1;
      var m = String(el.getAttribute('data-end') || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
      timers.push({
        el: el,
        dur: days * 86400000,
        anchor: m ? Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0)) : null
      });
    });
  }
  function tick() {
    var et = nowET();
    timers.forEach(function (t) {
      var diff;
      if (t.anchor !== null) { var since = (et - t.anchor) % t.dur; if (since < 0) since += t.dur; diff = t.dur - since; }
      else diff = t.dur - (Date.now() % t.dur);
      var hasD = !!t.el.querySelector('[data-cd-d]');
      set(t.el, '[data-cd-d]', pad(Math.floor(diff / 86400000)));
      set(t.el, '[data-cd-h]', pad(hasD ? Math.floor(diff % 86400000 / 3600000) : Math.floor(diff / 3600000)));
      set(t.el, '[data-cd-m]', pad(Math.floor(diff % 3600000 / 60000)));
      set(t.el, '[data-cd-s]', pad(Math.floor(diff % 60000 / 1000)));
    });
  }
  window.__yghRecurring = function () { scan(); tick(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.__yghRecurring);
  else window.__yghRecurring();
  setInterval(tick, 1000);
})();
